module.exports = __webpack_public_path__ + "img/NaturalLight-Headshot.00039493.jpeg";